const buildRecordViewerPath = (record, { mode, viaChromeExtension = false, page } = {}) => {
  const fileToken = record.file_token;
  const basePath = viaChromeExtension
    ? `/app/chrome/view/${fileToken}`
    : `/app/view/${fileToken}`;
  const params = new URLSearchParams();
  if (mode) params.set('from', mode.toLowerCase());
  if (record.send_token) params.set('sendToken', record.send_token);
  if (record.slug) params.set('assignedDocumentId', record.slug);
  if (record.patient) params.set('patient', 'true');
  // ENG-3693: 1-based page the viewer opens at.
  if (page) params.set('page', String(page));
  const qs = params.toString();
  return qs ? `${basePath}?${qs}` : basePath;
};

export default buildRecordViewerPath;
